'use client'
import {
  BUTTON_QUERY
} from "./chunk-OYEMYN5L.mjs";
import {
  IMAGE_QUERY
} from "./chunk-CWCKFIZP.mjs";

// src/api/common/card.ts
var CARD_QUERY = `
id
title
subtitle
description
button {${BUTTON_QUERY}}
image31{${IMAGE_QUERY}}
image11{${IMAGE_QUERY}}
icon{${IMAGE_QUERY}}
background{${IMAGE_QUERY}}
`;

export {
  CARD_QUERY
};
//# sourceMappingURL=chunk-YQN77GCQ.mjs.map